import restCrudActions from '../../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../../np-rest/rest';
import { snackActions } from '../../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'address',
    pluginName: 'ADDRESS',
    entityName: 'ADDRESS',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true
});

// Fetch Address action creators
export const fetchAddressInit = () => { return crudActions.fetchInit(); }
export const fetchAddressStart = () => { return crudActions.fetchStart(); }
export const fetchAddressSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchAddressFail = () => { return crudActions.fetchFail(); }

export const fetchAddressesCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchAddressStart());
        try {
            let countRes = await rest.post("address/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchAddressSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchAddressFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch address."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchAddressFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch address."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};
export const fetchAddresses = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchAddressStart());
        try {
            let listRes = await rest.post("address/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchAddressSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchAddressFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchAddressFail());

            return { data: [] };
        }
    }
};


// Create Address  action creators
export const createAddressInit = () => { return crudActions.createInit(); };
export const createAddressStart = () => { return crudActions.createStart(); };
export const createAddressSuccess = createdAddress => { return crudActions.createSuccess(createdAddress); };
export const createAddressFail = error => { return crudActions.createFail(error); };
export const createAddress = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createAddressStart());
        try {
            let res = await rest.post('/address/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created address.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createAddressFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create address."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create address."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createAddressFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete Address  action creators
export const bulkDeleteAddressInit = () => { return crudActions.bulkDeleteInit(); };
export const bulkDeleteAddressStart = () => { return crudActions.bulkDeleteStart(); };
export const bulkDeleteAddressSuccess = bulkDeleted => { return crudActions.bulkDeleteSuccess(bulkDeleted); };
export const bulkDeleteAddressFail = error => { return crudActions.bulkDeleteFail(error); };
export const bulkDeleteAddress = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteAddressStart());
        try {
            let res = await rest.post('/address/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteAddressSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted addresses.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteAddressFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete addresses."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete addresses."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteAddressFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit address  action creators
export const editAddressInit = () => { return crudActions.editInit(); };
export const editAddressStart = () => { return crudActions.editStart(); };
export const editAddressSuccess = editedAddress => { return crudActions.editSuccess(editedAddress); };
export const editAddressFail = error => { return crudActions.editFail(error); };

export const editAddress = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editAddressStart());
        try {
            let res = await rest.post('/address/save', params);
            if (res.data && res.data.succeeded) {
                // dispatch(editAddressSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated address.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editAddressFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit address."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit address."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editAddressFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load address action creators
export const loadAddressInit = () => { return crudActions.loadInit(); };
export const loadAddressStart = () => { return crudActions.loadStart(); };
export const loadAddressSuccess = loadedAddress => { return crudActions.loadSuccess(loadedAddress); };
export const loadAddressFail = error => { return crudActions.loadFail(error); };
export const loadAddress = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

